import * as Yup from 'yup'

export const withdrawLegalNameValidator = Yup.string()
  .required('请输入帐户持有者名称')
  .max(100, '请填入正确的姓名格式')
  .test(
    'legalName-format',
    '请填入正确的姓名格式',
    (value) =>
      !!value &&
      // 只能是中文、英文、空格與間隔號
      /^[\u4e00-\u9fa5a-zA-Z ·]+$/.test(value) &&
      // 空格與符號不能在開頭與結尾
      /^[\u4e00-\u9fa5a-zA-Z].*[\u4e00-\u9fa5a-zA-Z]$/.test(value) &&
      // 不能有連續的空格或間隔號
      !/([ ·]{2,})/.test(value)
  )

export const CHINESE_ALPHABET_PATTERN = /^[\u4e00-\u9fa5_a-zA-Z]*$/
export const withdrawBankNameValidator = Yup.string().test(
  'bankName-format',
  '请输入 100 字元以下中 / 英文银行名称',
  (value) => !!value && value.length < 100 && CHINESE_ALPHABET_PATTERN.test(value)
)

export const withdrawBankBranchNameValidator = Yup.string().test(
  'bankBranchName-format',
  '请输入 100 字元以下中 / 英文支行名稱',
  (value) => !value || (value.length < 100 && CHINESE_ALPHABET_PATTERN.test(value))
)

export const withdrawCardCodeValidator = Yup.string().test('cardNo-format', '仅可输入 16~20 位数字', (value) => {
  // 银行卡号通常是16到20位数字
  return !!value && /^[0-9]{16,20}$/.test(value)
})
